var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.loading)?_c('i',{staticClass:"el-icon-minus"}):_vm._e(),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"label-picker-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }